/**
 * GhostModalHeader - Standardized Ghost branding header for all modals
 * Uses the EXACT same /ghost-icon.png as the floating badge
 * 
 * Usage:
 *   <GhostModalHeader />
 *   <GhostModalHeader subtitle="Log Call Outcome" />
 */
const GhostModalHeader = ({ subtitle }) => (
  <div className="ghost-modal-header px-6 pt-5 pb-3 border-b border-slate-100" data-testid="ghost-modal-header">
    <div className="flex items-center gap-3">
      <img
        src="/ghost-icon.png"
        alt="Ghost"
        className="w-8 h-8 object-contain"
        style={{ width: '32px', height: '32px' }}
      />
      <div className="min-w-0">
        <p className="text-sm font-semibold text-slate-900 leading-tight">Ghost AI</p>
        <p className="text-[11px] text-slate-400 leading-tight">powered by Prestigious Companies</p>
      </div>
    </div>
    {subtitle && (
      <p className="text-base font-semibold text-slate-800 mt-3">{subtitle}</p>
    )}
  </div>
);

/**
 * Dark variant for dark-themed modals (like GhostLoginModal)
 */
export const GhostModalHeaderDark = ({ subtitle }) => (
  <div className="ghost-modal-header px-6 pt-5 pb-3 border-b border-white/10" data-testid="ghost-modal-header">
    <div className="flex items-center gap-3">
      <img
        src="/ghost-icon.png"
        alt="Ghost"
        className="w-8 h-8 object-contain"
        style={{ width: '32px', height: '32px' }}
      />
      <div className="min-w-0">
        <p className="text-sm font-semibold text-white leading-tight">Ghost AI</p>
        <p className="text-[11px] text-slate-400 leading-tight">powered by Prestigious Companies</p>
      </div>
    </div>
    {subtitle && (
      <p className="text-base font-semibold text-white/90 mt-3">{subtitle}</p>
    )}
  </div>
);

export default GhostModalHeader;
